import { Skeleton, Stack } from "@mui/material";

/** Default dimensions for mobile list item cards */
const LIST_ITEM_CARD_MOBILE_DEFAULTS = {
  imageWidth: 132,
  imageHeight: 96,
  gap: 1,
  padding: 1,
  textHeightSmall: 16,
  textHeightMedium: 20,
  textHeightLarge: 18,
  textWidthSmall: "60%",
  textWidthMedium: "80%",
  textWidthLarge: "40%",
};

/**
 * Skeleton component to show a loading state for list item cards on mobile.
 */
export function SkeletonProjectListItemCard(): JSX.Element {
  return (
    <Stack
      flexDirection="row"
      gap={LIST_ITEM_CARD_MOBILE_DEFAULTS.gap}
      p={LIST_ITEM_CARD_MOBILE_DEFAULTS.padding}
    >
      <Skeleton
        variant="rectangular"
        width={LIST_ITEM_CARD_MOBILE_DEFAULTS.imageWidth}
        height={LIST_ITEM_CARD_MOBILE_DEFAULTS.imageHeight}
        sx={{ borderRadius: 1 }}
      />

      <Stack flex={1} minWidth={0} justifyContent="space-between">
        <Stack gap={0.5}>
          <Skeleton
            width={LIST_ITEM_CARD_MOBILE_DEFAULTS.textWidthSmall}
            height={LIST_ITEM_CARD_MOBILE_DEFAULTS.textHeightSmall}
          />
          <Skeleton
            width={LIST_ITEM_CARD_MOBILE_DEFAULTS.textWidthMedium}
            height={LIST_ITEM_CARD_MOBILE_DEFAULTS.textHeightMedium}
          />
        </Stack>
        <Skeleton
          width={LIST_ITEM_CARD_MOBILE_DEFAULTS.textWidthLarge}
          height={LIST_ITEM_CARD_MOBILE_DEFAULTS.textHeightLarge}
        />
      </Stack>
    </Stack>
  );
}
